import { AddressInformation } from "./address-detail-info";

export class ShippingInformation {
    warehouseName: String;
    shippingDate: number;
    shippingMethod: String;
    weight: String;
    trackingNumber: String;
    phoneNumber: String;
    address: AddressInformation;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/shipping-info.ts